// import store from '@/state/store'
import guestMiddleware from './../middleware/guestMiddleware';
// import isSacrificialMiddleware from '../middleware/isSacrificialMiddleware'
import isEmployeeMiddleware from '../middleware/isEmployeeMiddleware';
import isMartyrMiddleware from '../middleware/isMartyrMiddleware';
import isWoundedMiddleware from '../middleware/isWoundedMiddleware';

export default [
 
  // {
  //   path: '/',
  //   name: 'default',
  //   component: () => import('./views/apartment-complex/employee')
  // },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  // {
  //   path: '/housing-units/martyrs/:code(\\d{10})',
  //   name: 'housingUnits.martyrs',
  //   component: () => import('./views/apartment-complex/martyr'),
  //   beforeEnter:isSacrificialMiddleware
  // },
  {
    path: '/housing-units/martyrs',
    name: 'housingUnits.martyrs',
    component: () => import('./views/apartment-complex/martyr-without-code'),
    beforeEnter:isMartyrMiddleware
  },
  {
    path: '/housing-units/woundeds',
    name: 'housingUnits.woundeds',
    component: () => import('./views/apartment-complex/injured'),
    beforeEnter: isWoundedMiddleware
  },
  {
    path: '/housing-units/employees',
    name: 'housingUnits.employees',
    component: () => import('./views/apartment-complex/employee'),
    beforeEnter: isEmployeeMiddleware
  },
  {
    path: '/housing-units/login',
    name: 'housingUnits.login',
    component: () => import('./views/account/login'),
    beforeEnter: guestMiddleware
  },
]
